import axios from "axios";
import { decode, encode } from "js-base64";
import { HttpJsonHeader } from "./Environments";

export const checkUser = (username, password) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_API + "user/authen",
        {
          data: encode(
            JSON.stringify({ Username: username, Password: password })
          ),
        },
        HttpJsonHeader
      )
      .then((response) => {
        var result = JSON.parse(decode(response.data));
        resolve(result);
      })
      .catch((err) => {
        reject(null);
      });
  });
